import { HttpStatusCode } from "types/types";

export type SrchDataErrorResponse = {
  error?: number;
  message?: string;
} | {
  returnCode?: number;
  errorMsg?: string;
  value?: null;
};

export type SrchDataClientErrorParams = {
  errorResponse: SrchDataErrorResponse;
  status: HttpStatusCode;
  url?: string;
};

export class SrchDataClientError extends Error {
  errorResponse: SrchDataErrorResponse;
  status: HttpStatusCode;
  url: string;

  constructor({ errorResponse, status, url }: SrchDataClientErrorParams) {
    super(JSON.stringify(errorResponse));
    this.name = "SrchDataClientError";
    this.errorResponse = errorResponse;
    this.status = status;
    this.url = url;
  }
}
